(function () {
  'use strict';

  function bindUpsell(retries) {
    retries = retries || 0;
    var block = document.getElementById('cart-upsell-block');
    if (!block || block.dataset.cuReady === '1') return;
    var track = document.getElementById('cu-track');
    if (!track) return;
    block.dataset.cuReady = '1';

    if (!track.dataset.shuffled) {
  track.dataset.shuffled = '1';

  var items = Array.from(track.children).filter(function(el) {
    return !el.dataset.clone;
  });

  var pinnedItems = items.filter(function(el) {
    return el.dataset.cuPinned === 'true';
  });

  var otherItems = items.filter(function(el) {
    return el.dataset.cuPinned !== 'true';
  });

  for (var i = otherItems.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = otherItems[i];
    otherItems[i] = otherItems[j];
    otherItems[j] = tmp;
  }

  pinnedItems.concat(otherItems).forEach(function(el) {
    track.appendChild(el);
  });
}

    // Limpiar clones previos si los hubiera (por retry)
    Array.from(track.children).forEach(function(el) {
      if (el.dataset.clone) el.remove();
    });

    // Carrusel infinito
    var firstClone = track.children[0].cloneNode(true);
    var lastClone = track.children[track.children.length - 1].cloneNode(true);
    firstClone.dataset.clone = 'first';
    lastClone.dataset.clone = 'last';
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.children[0]);

    // Forzar ancho exacto de cada item al del viewport
    var viewportEl = block.querySelector('.cu-viewport');
    var viewportWidth = viewportEl ? viewportEl.offsetWidth : block.offsetWidth;

    // Si el ancho es 0, el drawer aún no es visible — reintentar
    if (viewportWidth === 0) {
      Array.from(track.children).forEach(function(el) {
        if (el.dataset.clone) el.remove();
      });
      block.dataset.cuReady = '0';
      if (retries < 5) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            bindUpsell(retries + 1);
          });
        });
      }
      return;
    }

    Array.from(track.children).forEach(function(el) {
      el.style.width = viewportWidth + 'px';
      el.style.minWidth = viewportWidth + 'px';
      el.style.maxWidth = viewportWidth + 'px';
      el.style.flexShrink = '0';
      el.style.boxSizing = 'border-box';
    });

    // Forzar viewport para que nunca muestre el item siguiente
    viewportEl.style.width = viewportWidth + 'px';
    viewportEl.style.maxWidth = viewportWidth + 'px';
    viewportEl.style.overflow = 'hidden';

    var current = 1;
    function realTotal() { return track.children.length - 2; }
    function total() { return track.children.length; }

    // Contador
    var counter = block.querySelector('.cu-counter');
    function updateCounter() {
      if (!counter) return;
      var realIndex = current;
      if (realIndex <= 0) realIndex = realTotal();
      if (realIndex > realTotal()) realIndex = 1;
      counter.textContent = realIndex + '/' + realTotal();
    }

    function goTo(n, animate) {
      if (animate === false) track.style.transition = 'none';
      else track.style.transition = 'transform 0.35s ease';
      current = n;
      track.style.transform = 'translateX(-' + (100 * current) + '%)';
      updateCounter();
    }

    track.addEventListener('transitionend', function() {
      if (track.children[current] && track.children[current].dataset.clone === 'first') {
        goTo(1, false);
      }
      if (track.children[current] && track.children[current].dataset.clone === 'last') {
        goTo(total() - 2, false);
      }
    });

    goTo(1, false);
    if (counter) counter.textContent = '1/' + realTotal();

    var prev = block.querySelector('.cu-prev');
    var next = block.querySelector('.cu-next');
    if (prev) prev.onclick = function() { goTo(current - 1, true); };
    if (next) next.onclick = function() { goTo(current + 1, true); };

    block.querySelectorAll('[data-price-select]').forEach(function(sel) {
      var priceEl = sel.closest('.cu-info').querySelector('.cu-price');
      sel.onchange = function() {
        var raw = parseInt(sel.options[sel.selectedIndex].getAttribute('data-price'), 10);
        if (!isNaN(raw) && priceEl) priceEl.textContent = (raw/100).toFixed(2).replace('.',',') + '\u00a0\u20ac';
      };
    });

    block.querySelectorAll('[data-upsell-btn]').forEach(function(btn) {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var container = btn.closest('[data-upsell-form]');
        var sel = container && container.querySelector('[data-price-select]');
        var span = container && container.querySelector('[data-variant-id]');
        var vid = (sel && sel.value) || (span && span.getAttribute('data-variant-id'));
        if (!vid) return;
        btn.disabled = true;
        var originalText = btn.innerHTML;
        btn.innerHTML = '<span class="cu-spinner"></span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status && data.status >= 400) {
            btn.disabled = false;
            btn.innerHTML = originalText;
            return;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.updateCart === 'function') {
            drawer.updateCart();
          }
        })
        .catch(function(err) { console.error('[CU]', err); btn.disabled = false; btn.innerHTML = originalText; });
      };
    });
  }

  var observer = new MutationObserver(function(mutations) {
    var needsBind = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var node = added[k];
        if (node.nodeType !== 1) continue;
        if (node.id === 'cart-upsell-block' ||
            node.id === 'CartDrawer-CartItems' ||
            node.id === 'CartDrawer' ||
            (node.querySelector && node.querySelector('#cart-upsell-block'))) {
          needsBind = true;
          break;
        }
      }
      if (needsBind) break;
    }
    if (needsBind) {
      var b = document.getElementById('cart-upsell-block');
      if (b) b.dataset.cuReady = '0';
      bindUpsell(0);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { bindUpsell(0); });
  } else {
    bindUpsell(0);
  }

})();